import { RoutedModal } from "../../../../components/common";
import secondaryComponents from "../../../../components/secondaryComponents";
import primaryComponents from "../../../../components/primaryComponents";
import { ArrowRight, SaveIcon } from "../../../../assets/svgIcons";
import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";
import useReconcileStocks from "../../../appPages/Inventory/Reconciliation/ReconcileStocks/useReconcileStocks";

export const SMReconcileStock = () => {
  const {
    storeName,
    isSubmitting,
    isLoading,
    isFetchingNextPage,
    products,
    reconciliedData,
    isSaving,
    isLoadingDiscrepancy,
    discrepancyReasons,
    isReconciliationPrompt,
    categoryList,
    filters,
    storeDetails,
    setFilters,
    autoScrollRef,
    submitReconciliation,
    saveDraft,
    setReconciliedData,
    setIsReconciliationPrompt,
  } = useReconcileStocks();

  return (
    <RoutedModal
      isActive={true}
      hasPrevNavigation={true}
      headerTitle={`Stock Reconciliation - ${storeName}`}
      headerDescription="Please note that this page autosave every 5 mins"
      rightHeaderSide={
        <div className="d-flex ml-auto">
          <primaryComponents.Button
            classNames="btn btn--primary mr-2"
            onClick={() => setIsReconciliationPrompt(true)}
            isDisabled={isSubmitting}
            isLoading={isSubmitting}
            loadingText="Submitting..."
          >
            <ArrowRight style={{ fontSize: "20px" }} className="mr-1" />
            Submit
          </primaryComponents.Button>
          <primaryComponents.Button
            classNames="btn btn--outline"
            onClick={() => saveDraft(false)}
            isDisabled={isSaving}
          >
            <SaveIcon
              style={{ fontSize: "20px" }}
              className="dark--text mr-1"
            />
            Save
          </primaryComponents.Button>
        </div>
      }
    >
      <section className={`${globalStyles.cardWithBorder} overflow-hidden p-0`}>
        <div className={globalStyles.tableHeader}>
          <primaryComponents.SearchField
            classNames={globalStyles.searchField}
            placeholder="Search by product name"
            value={filters?.searchQuery}
            trigger={(value) =>
              setFilters((prev) => ({ ...prev, searchQuery: value }))
            }
            triggerOnInput={true}
            showsearchBtn
          />

          <div className="ml-auto" style={{ maxWidth: "350px", width: "100%" }}>
            <primaryComponents.MultipleSelectField
              name="categories"
              options={categoryList}
              idKey="id"
              nameKey="name"
              placeholder="Select Categories"
              onChange={(values) => {
                let newValues = [];
                values?.forEach((item) => {
                  newValues.push(item.value);
                });
                setFilters((prev) => ({ ...prev, categories: newValues }));
              }}
              floatError={false}
            />
          </div>
        </div>

        <div>
          <secondaryComponents.LoaderHelper
            classNames="my-5"
            isLoading={isLoading || isLoadingDiscrepancy}
          >
            <secondaryComponents.ReconcileStockEditView
              store_currency={storeDetails?.currency_code}
              products={products}
              autoScrollRef={autoScrollRef}
              setReconciliedData={setReconciliedData}
              reconciliedData={reconciliedData}
              discrepancyReasons={discrepancyReasons}
            />
          </secondaryComponents.LoaderHelper>

          <secondaryComponents.LoaderHelper
            classNames="mt-4"
            isLoading={isFetchingNextPage && !isLoading}
          ></secondaryComponents.LoaderHelper>
        </div>
      </section>

      <secondaryComponents.Modal
        isActive={isReconciliationPrompt}
        closeModal={() => setIsReconciliationPrompt(false)}
        width="500px"
      >
        <secondaryComponents.ReconciliationReviewPrompt
          closeModal={() => setIsReconciliationPrompt(false)}
          reconciliationType="firstSubmission"
          proceed={() => {
            submitReconciliation();
            setIsReconciliationPrompt(false);
          }}
        />
      </secondaryComponents.Modal>
    </RoutedModal>
  );
};
